import React, { Suspense, } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthChecker from "./authChecker";
import {
  AiEvaluationV1_Public,
  AiEvaluationV2,
  Certificate,
  Signin,
} from "Pages";
import Loader from "Components/Loader";
import NotFound from "Components/NotFound";
import { QueryProvider } from "Context/querContext";
import SuccessPage from "Components/SuccessPage";
// import TextToSpeech from "Components/texttosppech";
import DashboardWrapperV2 from "Layout/index";
import EncryptedHLSPlayer from "Components/EncryptedHLSPlayer";

interface RouteType {
  path: string;
  component: any;
  name: string;
  protected: boolean;
  allow12thPass: boolean
  allDomain?: boolean;
}




function Routers() {

  const routes: RouteType[] = [
    
    {
      path: "/v1/user/dashboard/:menu",
      component: <DashboardWrapperV2 />,
      name: "General Dashboard",
      protected: true,
      allow12thPass: false,    
    },

    {
      path: "/v1/program/dashboard/:menu",
      component: <DashboardWrapperV2 />,
      name: "Program Dashboard",
      protected: true,
      allow12thPass: false,
    },
    {
      path: "/certificate/:type/:id",
      component: <Certificate />,
      name: "Certificate",
      protected: false,
      allow12thPass: false,
    },
    {
      path: "/interview/:id",
      component: <AiEvaluationV1_Public />,
      name: "Public Interview",
      protected: false,
      allow12thPass: false,
    },
    {
      path: "/",
      component: <Signin />,
      name: "Signin Screen",
      protected: false,
      allow12thPass: false,
    },
    {
      path: "/text",
      component: <AiEvaluationV2 />,
      name: "JobAssurance New",
      protected: false,
      allow12thPass: false,
    },
    {
      path: "/testing",
      component: <>
        <div style={{ padding: '2rem' }}>
      <h2>Encrypted HLS Player</h2>
      <EncryptedHLSPlayer src="https://d1kudef04s3i6t.cloudfront.net/output-videos/GDPRO/GDPRO_!3/GDPRO_!3.m3u8" />
    </div>
      </>,
      name: "JobAssurance New",
      protected: false,
      allow12thPass: false,
    },
  ];
console.log(process.env.REACT_APP_ENVIRONMENT);

  return (
    <Suspense
      fallback={
        <div>
          <Loader />
        </div>
      }
    >
      <BrowserRouter>
      <QueryProvider>
        {/* <AppLayout> */}
        <Routes>
          {routes.map((route, index) => (<React.Fragment>
            {window.location.origin?.toLocaleLowerCase().includes(process.env.REACT_APP_ENVIRONMENT==="local"?'localhost-':'12thpass')&& (route.allow12thPass || route.allDomain )&&<Route
              key={index}
              path={route.path}
              element={
                route.protected ? (
                  <AuthChecker>{route.component}</AuthChecker>
                ) : (
                  route.component
                )
              }
            />}
            {window.location.origin?.toLocaleLowerCase().includes(process.env.REACT_APP_ENVIRONMENT==="local"?'localhost':'youvah') && (!route.allow12thPass || route.allDomain)&&<Route
              key={index}
              path={route.path}
              element={
                route.protected ? (
                  <AuthChecker>{route.component}</AuthChecker>
                ) : (
                  route.component
                )
              }
            />}
            </React.Fragment>
          ))}
          <Route path="*" element={<NotFound />} />
          <Route path="/success/:id" element={<SuccessPage />} />
        </Routes>
        {/* </AppLayout> */}
        </QueryProvider>
      </BrowserRouter>
    </Suspense>
  );
}

export default React.memo(Routers);
